import React, { useState, useRef, useEffect } from "react";
import "./AddTodoList.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import { colorOptions, normalizeColor } from "../../../../utils/colors";
import ColorPicker from "../../../../components/ColorPicker/ColorPicker";
import { useTranslation } from "react-i18next";

function AddTodoList({ createTodoList, cancelCreateTodoList }) {
  const { t } = useTranslation();
  const [title, setTitle] = useState("");
  const [selectedColor, setSelectedColor] = useState(colorOptions[0]);
  const [showTitleError, setShowTitleError] = useState(false);
  const [listType, setListType] = useState("todo"); // "todo" or "checklist"

  const handleCreateTodoList = () => {
    if (title.trim()) {
      const colorHex = normalizeColor(selectedColor);
      createTodoList(title.trim(), colorHex, listType);
      setTitle("");
      setSelectedColor(colorOptions[0]);
      setListType("todo");
      setShowTitleError(false);
    } else {
      setShowTitleError(true);
    }
  };

  const inputRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="add-todolist-content">
      <div className="modal-title">
        <div>{t("lists.modals.addList")}</div>
      </div>
      <div className="modal-form">
        <div className="modal-form-title">{t("common.title")}</div>
        <input
          ref={inputRef}
          type="text"
          className="modal-text-input"
          placeholder={t("lists.modals.titlePlaceholderExample")}
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
            if (showTitleError && e.target.value.trim()) {
              setShowTitleError(false);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleCreateTodoList();
            }
          }}
        />
        {showTitleError && (
          <div className="modal-helper-text">
            {t("lists.modals.titleRequired")}
          </div>
        )}

        <div className="modal-form-title">{t("lists.type")}</div>
        <div className="modal-checkbox-group">
          <label className="modal-checkbox-label">
            <input
              type="checkbox"
              checked={listType === "todo"}
              onChange={() => setListType("todo")}
            />
            <span>{t("lists.todoList")}</span>
          </label>
          <label className="modal-checkbox-label">
            <input
              type="checkbox"
              checked={listType === "checklist"}
              onChange={() => setListType("checklist")}
            />
            <span>{t("lists.checklist")}</span>
          </label>
        </div>

        <div className="modal-form-title">{t("common.color")}</div>
        <div className="color-picker-wrapper">
          <ColorPicker
            selectedColor={selectedColor}
            onColorSelect={setSelectedColor}
          />
        </div>

        <div className="modal-form-buttons">
          <button
            className="modal-button cancel"
            onClick={() => {
              setTitle("");
              setSelectedColor(colorOptions[0]);
              setListType("todo");
              setShowTitleError(false);
              cancelCreateTodoList();
            }}
          >
            {t("common.cancel")}
          </button>
          <button className="modal-button save" onClick={handleCreateTodoList}>
            {t("common.create")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddTodoList;
